import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TaskService } from '../../../../services';
import { InspectionsService } from '../../../../services/inspections.service';
import { MessageService } from 'primeng';
import { Message } from '../../../../classes/Message';
import {
  JobScreenInspectionHandover,
  JobScreenInspectionHandoverMedia,
} from '../../../../interfaces/screen-specific/job-screen/common/job-screen-inspection-handover';
import { finalize } from 'rxjs/operators';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'job-screen-inspection-handover',
  templateUrl: './job-screen-inspection-handover.component.html',
  styleUrls: ['./job-screen-inspection-handover.component.scss'],
})
export class JobScreenInspectionHandoverComponent implements OnChanges {
  @Input('taskId') taskId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  loading: boolean = false;
  isAddInspectionRecordingVisible: boolean = false;
  isViewInspectionRecordingVisible: boolean = false;
  isUploading: boolean = false;
  videoDescription: string = '';
  uploadProgress: number = 0;
  inspectionHandover: JobScreenInspectionHandover;
  selectedMedia: JobScreenInspectionHandoverMedia;

  constructor(
    private taskService: TaskService,
    private inspectionsService: InspectionsService,
    private messageService: MessageService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taskId) {
      this.fetchHandover(this.taskId).then(() => {});
    }
  }

  async fetchHandover(taskId: number) {
    this.loading = true;
    return this.taskService
      .getForComponent(taskId, 'job-screen-inspection-handover')
      .then((handover: JobScreenInspectionHandover) => {
        this.inspectionHandover = handover;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  showAddInspectionRecording(): void {
    this.isAddInspectionRecordingVisible = true;
  }

  handleInspectionRecordingUpload(): void {
    const file = this.fileInput.nativeElement.files?.[0];

    if (!file) {
      this.messageService.add(Message.Error('No file found. Please re-attach and try again.'));
      return;
    }

    this.isUploading = true;

    this.inspectionsService
      .generatePreSignedUrlForInspectionUpload(this.taskId, file.name)
      .then((response) => {
        this.uploadToS3(file, response.url, response.objectKey);
      })
      .catch((error) => {
        this.messageService.add(
          Message.Error(
            'An error occurred while uploading the inspection recording. Please try again.',
          ),
        );
        this.isUploading = false;
      });
  }

  private uploadToS3(file: File, presignedUrl: string, fileKey: string): void {
    this.inspectionsService
      .uploadFileToS3(file, presignedUrl)
      .pipe(
        finalize(() => {
          this.isUploading = false;
        }),
      )
      .subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.uploadProgress = Math.round((event.loaded / event.total) * 100);
          } else if (event.type === HttpEventType.Response) {
            this.inspectionsService
              .completeInspectionMediaUpload(this.taskId, file.name, fileKey, this.videoDescription)
              .then((response) => {
                this.messageService.add(
                  Message.Success('Inspection recording uploaded successfully'),
                );
                this.close();
                void this.fetchHandover(this.taskId);
              })
              .catch((error) => {
                this.messageService.add(
                  Message.Error(
                    'An error occurred while uploading the inspection recording. Please try again.',
                  ),
                );
              });
          }
        },
        error: (error) => {
          this.messageService.add(
            Message.Error(
              'An error occurred while uploading the inspection recording. Please try again.',
            ),
          );
        },
      });
  }

  close(): void {
    this.videoDescription = '';
    this.uploadProgress = 0;
    this.fileInput.nativeElement.value = '';
    this.isAddInspectionRecordingVisible = false;
  }

  viewMedia(media: JobScreenInspectionHandoverMedia): void {
    this.selectedMedia = media;
    this.isViewInspectionRecordingVisible = true;
  }
}
